/**
 * Fragebogen.class
 *
 * (c) notwenidges übel UG, Dimitri Preiß (preiss@notwenidges-uebel.de)
 */

export default class Frage {
    config = {};

    constructor(elem, config) {
        this.config = {...this.config, ...config};
        this.elem = elem;

        this.radios = Array.from(this.elem.querySelectorAll('[type="radio"]'));
        this.status = '';

        this.parent = this.elem.closest('[data-cheet-item]');

        this.radios.forEach((radio) => {
            radio.addEventListener('click', (e) => {
                this.status = e.target.value;

                if ('createEvent' in document) {
                    const evt = document.createEvent('HTMLEvents');
                    evt.initEvent('change', false, true);
                    this.parent.dispatchEvent(evt);
                } else {
                    this.parent.fireEvent('onchange');
                }
            });
        });
    }

    getStatus() {
        return this.status;
    }
}
